import React, { useContext } from 'react';
import { KFLRadioButton } from '@kamstrup/kamstrup-frontend-library';
import * as ReadRights from '../../modules/dialogs/readRights';
import { Groups, SelectMode } from '../../models';
import Translate from '../shared/localization/localize';
import { LocaleCtx } from '../../contexts/locale.context';
import Badge from '../shared/badge';

type ReadRighsModeType = ReadRights.Data & ReadRights.View;
const ReadRightsMode: React.FC<ReadRighsModeType> = ({
  groupedBy,
  mode,
  keys,
}) => {
  const { translate } = useContext(LocaleCtx);
  const numKeys = keys.length;
  const selectedKey = numKeys === 1 ? String(keys[0]) : '';
  const viewMsg = ReadRights.getViewMsg(groupedBy, numKeys);

  return groupedBy === Groups.DEVICES ? (
    <div className="donwload_modes">
      <span className="download_mode_opt">
        <KFLRadioButton
          checked={mode === SelectMode.Selected}
          disabled={keys.length === 0}
          id="download-mode-selected"
          label={translate(ReadRights.msgDevicesSelected)}
          name="download-selection"
          onChange={() => ReadRights.setMode(groupedBy, SelectMode.Selected)}
        />
        <span className="num_devices">
          {keys.length > 0 && <Badge lightTheme>{keys.length}</Badge>}
        </span>
      </span>
      <KFLRadioButton
        checked={mode === SelectMode.All}
        id="download-mode-all"
        label={translate(ReadRights.msgDevicesAll)}
        name="download-selection"
        onChange={() => ReadRights.setMode(groupedBy, SelectMode.All)}
      />
    </div>
  ) : (
    <div>
      <Translate message={viewMsg} />
      <strong>{selectedKey ? ` ${selectedKey}` : ''}</strong>
    </div>
  );
};

export default ReadRightsMode;
